import React, { useState } from 'react';
import './Header.css';

function Header({ currentPage, setCurrentPage, onSearch }) {
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      onSearch(searchQuery.trim());
    }
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);
    // Live search as user types
    onSearch(value.trim());
  };

  return (
    <header className="header">
      <div className="header-container">
        <button className="logo" onClick={() => setCurrentPage('home')}>
          <img src="/crunch.png" alt="Crunch" className="logo-img" />
        </button>

        <nav className="nav">
          <button
            className={`nav-link ${currentPage === 'home' ? 'active' : ''}`}
            onClick={() => setCurrentPage('home')}
          >
            Home
          </button>
          <button
            className={`nav-link ${currentPage === 'about' ? 'active' : ''}`}
            onClick={() => setCurrentPage('about')}
          >
            About
          </button>
          
          <div className="nav-dropdown">
            <button
              className={`nav-link ${currentPage === 'laminates' ? 'active' : ''}`}
              onClick={() => setCurrentPage('laminates')}
            >
              Laminates
            </button>
            <div className="dropdown-menu">
              <button className="dropdown-item" onClick={() => setCurrentPage('laminates')}>
                0.8mm
              </button>
            </div>
          </div>
          
          <button
            className={`nav-link ${currentPage === 'contact' ? 'active' : ''}`}
            onClick={() => setCurrentPage('contact')}
          >
            Contact Us
          </button>
        </nav>

        <form className="search-form" onSubmit={handleSearch}>
          <input
            type="text"
            className="search-input"
            placeholder="Search designs..."
            value={searchQuery}
            onChange={handleSearchChange}
          />
          <button type="submit" className="search-btn">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="11" cy="11" r="8"></circle>
              <path d="m21 21-4.35-4.35"></path>
            </svg>
          </button>
        </form>
      </div>
    </header>
  );
}

export default Header;
